export default "__VITE_ASSET__77335a57__"